<template>
  <div>
    {{data}}
    <ModuleHeader>{{ data.nom }}</ModuleHeader>
    <v-alert color="info" text>
      <h4>
        Saldo : {{ $pgsHelper.formatNumber(data.cnt) }} {{ $Currencies.getCurrencyDefault() }}<br />

      </h4>
    </v-alert>

    <v-row>

      <v-col md="10" class="text-right">
        <v-btn color="green" dark @click="exportExcel">
          <v-icon>mdi-file-excel-box</v-icon>
          Exportar a Excel
        </v-btn>
      </v-col>
      <v-col v-if="false" md="10" class="text-right">
        <v-btn color="green" dark><v-icon>mdi-file-excel-box</v-icon>
          <download-excel class="exportExcel" type="xls" name="Monederos.xls" :data="movimientos">
            Exportar a Excel
          </download-excel>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="false">
      <v-col col="12" md="3">
        <v-text-field v-model="descripcion" label="Descripción"> </v-text-field>
      </v-col>
      <v-col col="12" md="3">
        <v-text-field v-model="cantidad" @keypress="$pgsHelper.onlyNumber($event, cantidad)" label="Cantidad">
        </v-text-field>
      </v-col>
      <v-col col="12" md="3">
        <v-select v-model="tipo" :items="[
          { value: 'D', text: 'Deposito' },
          { value: 'R', text: 'Retiro' },
        ]">
        </v-select>
      </v-col>
      <v-col col="12" md="3">
        <v-btn @click="addMov()" color="primary"> Agregar </v-btn>
      </v-col>
    </v-row>
    {{movimientos}}
    <v-simple-table fixed-header height="300px">
      <thead>
        <tr>
          <th>Movimiento</th>
          <th>Cantidad</th>
          <th>Cantidad {{ $Currencies.getCurrencyDefault() }}</th>
          <th>Saldo Desp. Mov.</th>
          <th>Tipo</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(producto, index) in movimientos">
          <tr :key="index">
            <td>
              {{ producto.ds }}<br />{{ producto.fe }}<br />
              <b v-if="producto._m">{{ producto._m.og }}</b>
            </td>

            <td>{{ producto }} </td>
            <td>
              {{ producto.Cantidad * 1 }} {{ $Currencies.getCurrencyDefault() }}
            </td>
            <td>
              Antes:<b>{{ $pgsHelper.formatNumber(producto.SaldoAnterior) }}</b><br />
              Despues :<b>
                {{ $pgsHelper.formatNumber(producto.SaldoPosterior) }}</b>
            </td>
            <td>
              <i v-if="producto._Op == 'R'" style="font-size: 20px; color: red" class="lni lni-arrow-down-circle"></i>
              <i v-if="producto._Op == 'D'" style="font-size: 20px; color: green" class="lni lni-arrow-up-circle"></i>
            </td>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
//const $ = require('jquery');
//window.$ = $;
import moment from "moment";
import FormMonederoExcel from "../../../clases/ExcelMaker/FormMonederoExcel";
import CreditBook from "../../../clases/CreditBooks/CreditBook.js";
//import axiosCore from 'axios'

export default {
  name: "CreditBookMovimientos",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      data: CreditBook.getPropertyModel(),
      nombre: "",
      saldo: "",
      saldoConverse: "",
      movimientos: [],
      descripcion: "",
      cantidad: "",
      tipo: "D",

      Id: "",
      errors: {},
      loader: true,
    };
  },
  methods: {
    exportExcel() {
      FormMonederoExcel.generateExcelBuffer(this.movimientos)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `MONEDERO ${this.nombre}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.error("Error exportando a Excel:", err);
        });
    },
    async getMovimientosMonedero() {
      let movimientos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_DineroElectronicoPaginasMovimientos", [
        firestore.where("del", "==", this.data.id),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      console.log(document)
      let OrderDocs = this.$_.orderBy(document, ["cat"], ["asc"]);
      OrderDocs.forEach((doc, indexDoc) => {
        let withoutInitialcharge = doc.mvs.filter(
          (mov) => mov.ds != "Creacion Monedero"
        );
        withoutInitialcharge.forEach((mov, index) => {
          //mov.Cliente = this.nombre;
          mov.Index = Number(indexDoc + "" + index);
          movimientos.push(mov);
        });
      });
      let orderMovs = this.$_.orderBy(
        movimientos,
        ["fe", "Index"],
        ["asc", "asc"]
      );
      let saldoAnterior = 0;

      orderMovs.forEach((mov) => {
        mov.SaldoAnterior = saldoAnterior;
        if (mov._Op == "D") {
          saldoAnterior = saldoAnterior + mov.Cantidad;
        } else {
          saldoAnterior = saldoAnterior - mov.Cantidad;
        }
        mov.SaldoPosterior = saldoAnterior;
      });
      //this.movimientos = orderMovs
      this.movimientos = this.$_.orderBy(
        orderMovs,
        ["fe", "Index"],
        ["desc", "desc"]
      );
    },
    addMov() {
      let datos = {
        Id: this.Id,
        Movimientos: [
          {
            Fecha: new moment().format("YYYY-MM-DD"),
            Cantidad: Number(this.cantidad),
            Descripcion: this.descripcion + " (Desde Admin)",
            _Op: this.tipo,
          },
        ],
      };
      this.$swal({
        allowOutsideClick: false,
        title: "¿Deseas agregar este movimiento?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Monederos-agregarMovimientos", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          // this.$emit('reloadClient');
          if (result.value.data.ok) {
            this.$swal({
              allowOutsideClick: false,
              title: "Guardado",
              text: "El movimiento se guardo correctamente",
              icon: "success",
            }).then(() => {
              if (datos.Movimientos[0]._Op != "R") {
                this.movimientos.push(datos.Movimientos[0]);
                this.saldo = this.saldo + datos.Movimientos[0].Cantidad;
                this.saldoConverse =
                  this.saldoConverse + datos.Movimientos[0].Cantidad * 1;
              } else {
                this.movimientos.push(datos.Movimientos[0]);
                this.saldo = this.saldo - datos.Movimientos[0].Cantidad;
                this.saldoConverse =
                  this.saldoConverse - datos.Movimientos[0].Cantidad * 1;
              }

              this.descripcion = "";
              this.cantidad = "";
            });
            this.$emit("reloadClients");
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.nombre) {
        this.errors.nombre = "El nombre del cupón es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      if (!this.mayorista) {
        this.errors.mayorista = "La agencia es obligatoria";
        valid = false;
      } else {
        this.errors.mayorista = false;
      }

      if (!this.cuponesIlimitados) {
        if (!this.cantidad) {
          this.errors.cantidad = "La cantidad de cupones es obligatoria";
          valid = false;
        } else {
          this.errors.cantidad = false;
        }
      }

      if (this.costoCupon.toString() == "") {
        this.$pgsHelper.log("invalido");
        this.errors.costoCupon = "el costo del cupón es obligatorio";
        valid = false;
      } else {
        this.$pgsHelper.log("valido");
        this.errors.costoCupon = false;
      }

      if (this.productos.length == 0) {
        this.errors.Producto = "Agregue al menos un producto";
        valid = false;
      } else {
        this.errors.Producto = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    counters() {
      let entradas = 0;
      let salidas = 0;
      this.movimientos.forEach((mov) => {
        if (mov._Op == "D") {
          entradas += mov.Cantidad;
        } else {
          salidas += mov.Cantidad;
        }
      });
      return { Ingresos: entradas, Salidas: salidas };
    },
  },
  watch: {},
  beforeMount: function () {
    this.loader = true;
  },
  mounted() {
    this.loader = false;

    if (this.edit) {

      const cbmodel = new CreditBook(this.dataEdit)
      console.log(cbmodel)
      this.data = cbmodel.properties
      this.getMovimientosMonedero()
    }
  },
};
</script>
